import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=fc73c20c"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports